import { render, staticRenderFns } from "./SiteDocumentsComponent.vue?vue&type=template&id=78ade84e&scoped=true"
import script from "./SiteDocumentsComponent.vue?vue&type=script&lang=js"
export * from "./SiteDocumentsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ade84e",
  null
  
)

export default component.exports